import React, { useState } from "react";

export default function EmployeeLogin() {
  const [pin, setPin] = useState("");
  const [employee, setEmployee] = useState(null);
  const [error, setError] = useState("");
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setEmployee(null);
    try {
  const res = await fetch("/php/employee_portal.php?action=login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pin })
      });
      if (!res.ok) throw new Error("Nesprávny PIN alebo chyba načítania");
      const data = await res.json();
      setEmployee(data);
    } catch (e) {
      setError(e.message || "Chyba prihlásenia");
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploadStatus("");
    const formData = new FormData();
    formData.append("pin", pin);
    formData.append("file", file);
    try {
  const res = await fetch("/php/employee_portal.php?action=upload", {
        method: "POST",
        body: formData
      });
      if (!res.ok) throw new Error("Chyba uploadu");
      setUploadStatus("Dokument úspešne nahraný.");
      setFile(null);
    } catch (e) {
      setUploadStatus(e.message || "Chyba uploadu");
    }
  };

  if (!employee) {
    return (
      <div style={{ maxWidth: 400, margin: "2rem auto", background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 2px 16px #0001" }}>
        <h2>Prihlásenie zamestnanca</h2>
        <form onSubmit={handleLogin}>
          <input type="password" inputMode="numeric" placeholder="Váš PIN" maxLength={4} value={pin} onChange={e => setPin(e.target.value.replace(/\D/g, ""))} required style={{ marginBottom: 12 }} />
          <button type="submit">Prihlásiť sa</button>
        </form>
        {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600, margin: "2rem auto", background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 2px 16px #0001" }}>
      <h2>Vitajte, {employee.meno} {employee.priezvisko}</h2>
      <div style={{ marginBottom: 16 }}>
        <b>Vaše údaje:</b>
        <div style={{ background: '#f8f8ff', padding: 12, borderRadius: 8, margin: '12px 0', fontSize: '1em' }}>
          {Object.entries(employee).filter(([k]) => k !== 'id' && k !== 'povinnosti' && k !== 'casovaPeciatka' && k !== 'firma').map(([k, v]) => (
            v ? <div key={k}><b>{k}:</b> {String(v)}</div> : null
          ))}
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>Môžete nahrať dokumenty (napr. potvrdenia, zmluvy):</div>
      <form onSubmit={handleUpload}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit" style={{ marginLeft: 8 }}>Nahrať</button>
      </form>
      {uploadStatus && <div style={{ marginTop: 12 }}>{uploadStatus}</div>}
    </div>
  );
}
